/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A reading the proposed question is based on.
 */
export interface ReferringResource {
  id: string;
  title: string;
}
